import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { COLORS } from "components";

export const SendReminderModalFooter = ({
  recipientCount,
  isSending,
  onClose,
  onSend,
}: {
  recipientCount: number;
  isSending: boolean;
  onClose: () => void;
  onSend: () => void;
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 3,
      py: 2,
      borderTop: "1px solid",
      borderColor: "divider",
      flexShrink: 0,
    }}
  >
    <Typography variant="body2" color="text.secondary">
      Ready to send to {recipientCount} recipient
      {recipientCount !== 1 ? "s" : ""}
    </Typography>
    <Box sx={{ display: "flex", gap: 1.5 }}>
      <Button
        onClick={onClose}
        variant="outlined"
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          px: 3,
          borderColor: "grey.300",
          color: "text.primary",
          "&:hover": { borderColor: "grey.400", backgroundColor: "grey.50" },
        }}
      >
        Cancel
      </Button>
      <Button
        onClick={onSend}
        variant="contained"
        disabled={isSending || recipientCount === 0}
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          px: 3,
          backgroundColor: COLORS.lightGreen,
          "&:hover": { backgroundColor: COLORS.greenDarker },
          "&.Mui-disabled": { backgroundColor: "grey.300", color: "grey.500" },
        }}
      >
        {isSending ? "Sending..." : "Send"}
      </Button>
    </Box>
  </Box>
);
